import React from 'react'
import style from './TextContent.module.css'

const TextContent = () => {
    return (
        <div className={style.TextContent}>
            <h1 className={style.mainHeading}>Sri Radhastami Celebrations | ISKCON Vijayawada</h1>

            <p className={style.patagContent}>
                Sri Radhastami marks the appearance of Srimati Radharani, the eternal consort of Lord Krishna and the embodiment of devotion, compassion, and mercy. On this sacred day, devotees worldwide glorify Her through music, prayers, and offerings, seeking Her blessings to progress in pure bhakti.
                ISKCON Vijayawada joyfully welcomes you to our devotional family and invites you to connect with us for spiritual guidance, to offer seva to Sri Sri Radha Shyam Sundar or Sri Jagannath, Baldev, and Subhadra, or to learn more about our programs, services, and courses. We deeply value your association, and service, and remain committed to supporting your spiritual journey. Hare Krishna!

            </p>

            <h2 className={style.FHheading}>Festival Highlights</h2>
        </div>
    )
}

export default TextContent
